module.exports = __webpack_public_path__ + "img/QuestionCircle.8120cd96.svg";